import React, { useState } from 'react'
import { Add, Remove } from '@mui/icons-material'
import { Box, FormControl, TextField, Button } from '@mui/material'

export const MultiTextItemFieldPlusExtras = (props: any) => {
  const { onChange } = props
  const [lineItems, setLineItems] = useState([{ lineItemValue: '', quantity: 0, supplier: '' }])

  const onAddLineItem = () => {
    const newLineItems = [...lineItems, { lineItemValue: '', quantity: 0, supplier: '' }]
    setLineItems(newLineItems)
    onChange(newLineItems)
  }

  const onRemoveLineItem = (index: number) => {
    const newLineItems = [...lineItems]
    newLineItems.splice(index, 1)
    setLineItems(newLineItems)
    onChange(newLineItems)
  }

  const onLineItemChange = (event: any, index: number) => {
    const newLineItems = [...lineItems]
    newLineItems[index].lineItemValue = event.target.value
    setLineItems(newLineItems)
    onChange(newLineItems)
  }

  const onLineItemQuantityChange = (event: any, index: number) => {
    const newLineItems = [...lineItems]
    newLineItems[index].quantity = event.target.value ? parseInt(event.target.value, 10) : 0
    setLineItems(newLineItems)
    onChange(newLineItems)
  }

  const onLineItemSupplierChange = (event: any, index: number) => {
    const newLineItems = [...lineItems]
    newLineItems[index].supplier = event.target.value
    setLineItems(newLineItems)
    onChange(newLineItems)
  }

  return (
    <Box
      sx={{ flex: 1, alignItems: 'center', alignContent: 'flex-start', mt: 2 }}>
      {lineItems.map((lineItem, key: number) => {
        return (
          <Box key={key} sx={{}}>
            <FormControl sx={{ m: 1, width: { lg: 450, sm: '55%' }, mx: 0, paddingRight: '15px' }}>
              <TextField
                name='lineitem'
                variant='filled'
                fullWidth={true}
                value={lineItem.lineItemValue}
                onChange={e => onLineItemChange(e, key)}
                placeholder='Item'
              />
            </FormControl>
            <FormControl sx={{ m: 1, width: { lg: 100, sm: '15%' }, mx: 0, paddingRight: '15px' }}>
              <TextField
                label='Quantity'
                name='quantity'
                variant='filled'
                fullWidth={true}
                value={lineItem.quantity}
                onChange={e => onLineItemQuantityChange(e, key)}
              />
            </FormControl>
            <FormControl sx={{ m: 1, width: { lg: 270, sm: '30%' }, mx: 0, paddingRight: '15px' }}>
              <TextField
                name='supplier'
                variant='filled'
                fullWidth={true}
                value={lineItem.supplier}
                onChange={e => onLineItemSupplierChange(e, key)}
                placeholder='Supplier'
              />
            </FormControl>
            {lineItems.length === key+1 && (
            <Button
              variant='contained'
              color='secondary'
              sx={{ m: 1, padding: '16px 26px' }}
              onClick={onAddLineItem}
              startIcon={<Add />}>
              Add
            </Button>
            )}
            {lineItems.length > 1 && (
              <Button
                variant='contained'
                color='secondary'
                sx={{ m: 1, padding: '16px 26px' }}
                onClick={() => onRemoveLineItem(key)}
                startIcon={<Remove />}></Button>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
